import React from 'react';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Radio, Button, Modal, Form, Row, Col, Icon, Input, Select, DatePicker, Spin, Popconfirm } from 'antd';
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
import { handleSearch, getReportData, getExportUrl } from './action';
import { connect } from 'react-redux';
import { trunRangePicker } from './constant';
import moment from 'moment';
import './styles.css';

class Report extends React.Component {

    constructor(props) {
        super(props);
        this.handleOnFieldsChange = this.handleOnFieldsChange.bind(this);
    }

    componentDidMount() {
        this.props.getReportData(); //查询任务统计的echarts数据
    }

    componentWillUnmount() {
        let _serach = this.props.search;
        let _obj = {};
        Object.keys(_serach).forEach((key, index) => {
            _obj[key] = '';
        });
        this.props.handleSearch(Object.assign(_obj, { 'sBeginTime': moment().format('YYYY-MM-DD'), 'sEndTime': moment().format('YYYY-MM-DD') }));
    }

    handleOnFieldsChange(fields) {
        let _obj = {};
        Object.keys(fields).forEach((key, index) => {
            if (key === 'filtration') {
                _obj['time'] = undefined;              //互斥显示
                _obj['filtration'] = fields[key].value;//互斥显示
                _obj['sBeginTime'] = moment(fields[key].value[0]).format('YYYY-MM-DD');
                _obj['sEndTime'] = moment(fields[key].value[1]).format('YYYY-MM-DD');
            } else {
                _obj['time'] = fields[key].value;//互斥显示
                _obj['filtration'] = undefined;  //互斥显示
                switch (fields[key].value) {
                    case '1'://今日
                        _obj['sBeginTime'] = moment().format('YYYY-MM-DD');
                        _obj['sEndTime'] = moment().format('YYYY-MM-DD');
                        break;
                    case '2'://昨日
                        _obj['sBeginTime'] = moment().subtract(1, 'days').format('YYYY-MM-DD');
                        _obj['sEndTime'] = moment().subtract(1, 'days').format('YYYY-MM-DD');
                        break;
                }
            }
        });
        this.props.handleSearch(Object.assign(_obj));
        this.props.getExportUrl();
        this.fieldsOnChangeImpl(fields);
    }

    fieldsOnChangeImpl(fields) {
        Object.keys(fields).forEach((key, index) => {
            if (key === 'time') {
                this.props.getReportData();
            }
        });
    }


    render() {
        const { loading, reportData } = this.props;
        return (
            <div style={{ marginBottom: '20px' }}>
                <Spin spinning={loading} tip="加载中">
                    <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                        <SearchForm {...this.props} handleOnFieldsChange={this.handleOnFieldsChange} />
                    </Row>
                    <table border="1px" className="gridtable" cellSpacing="0" cellPadding="0">
                        <tr>
                            <th>广告ID</th>
                            <th>广告名称</th>
                            <th>广告位</th>
                            <th>UV</th>
                            <th>曝光量</th>
                            <th>点击量</th>
                            <th>广告语1</th>
                            <th>广告语2</th>
                            <th>广告语3</th>
                            <th>广告语4</th>
                            <th>广告语5</th>
                            <th>广告语6</th>
                            <th>广告语7</th>
                            <th>广告语8</th>
                            <th>广告语9</th>
                        </tr>
                        {
                            Object.keys(reportData).map((adInfo, index) => {
                                let detailInfos = reportData[adInfo];
                                let ad = JSON.parse(adInfo)
                                return Object.keys(detailInfos).map((date, infoIndex, array) => {
                                    let detailInfo = detailInfos[date];
                                    return (<tr>
                                        {infoIndex === 0 ? <td rowSpan={array.length}>{ad.adid}</td> : ""}
                                        {infoIndex === 0 ? <td rowSpan={array.length}>{ad.adName}</td> : ""}
                                        <td>{detailInfo.tm}</td>
                                        <td>{detailInfo.uv}</td>
                                        <td>{detailInfo.evPv}</td>
                                        <td>{detailInfo.clickPv}</td>
                                        <td>{detailInfo.adPs1}</td>
                                        <td>{detailInfo.adPs2}</td>
                                        <td>{detailInfo.adPs3}</td>
                                        <td>{detailInfo.adPs4}</td>
                                        <td>{detailInfo.adPs5}</td>
                                        <td>{detailInfo.adPs6}</td>
                                        <td>{detailInfo.adPs7}</td>
                                        <td>{detailInfo.adPs8}</td>
                                        <td>{detailInfo.adPs9}</td>
                                    </tr>);

                                })
                            })
                        }
                    </table >
                </Spin >
            </div >
        );
    }
}

const mapStateToProps = state => ({
    loading: state.report.loading,
    search: state.report.search,
    reportData: state.report.reportData,
    exportUrl: state.report.url,
});

const mapDispatchToProps = dispatch => ({
    handleSearch: search => dispatch(handleSearch(search)),
    getReportData: () => dispatch(getReportData()),
    getExportUrl: () => dispatch(getExportUrl()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Report);

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.handleSearch = this.handleSearch.bind(this);
    }

    //查询
    handleSearch(e) {
        e.preventDefault();
        this.props.getReportData();
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>统计报表</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={4}>
                            <FormItem>
                                {getFieldDecorator('time', {
                                    initialValue: '1'
                                })(<RadioGroup>
                                    <RadioButton value="1">今日</RadioButton>
                                    <RadioButton value="2">昨日</RadioButton>
                                </RadioGroup>)}
                            </FormItem>
                        </Col>
                        <Col span={9}>
                            <FormItem>
                                {getFieldDecorator('filtration')(
                                    <RangePicker />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={10} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button type="primary" htmlType="submit">
                                搜索
                            </Button>
                            <Button style={{ marginLeft: 8 }} >
                                <a href={this.props.exportUrl} download="filename">导出</a>
                            </Button>
                        </Col>

                    </Row>
                </Form>
            </div>
        );
    }
}
const SearchForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleOnFieldsChange(fields);
    },
    mapPropsToFields(props) {
        return {
            time: {
                value: props.search.time
            },
            filtration: {
                value: props.search.filtration
            },
        }
    }
})(Search);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/report/index.js